import {rootApi} from '..';

export const ytApi = rootApi.injectEndpoints({
    endpoints: () => ({}),
});
